import React from "react";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  ButtonGroup,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { animateScroll as scroll } from "react-scroll";

const CustomPagination = ({
  currentPage,
  totalPages,
  onPageChange,
  pageSize,
  setPageSize,
  setPageNo,
  showPageSizeDropdown = true,
}) => {
  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 5) {
      for (let i = 0; i < totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(0);
      if (currentPage > 2) pages.push("start-ellipsis");

      const start = Math.max(1, currentPage - 1);
      const end = Math.min(totalPages - 2, currentPage + 1);
      for (let i = start; i <= end; i++) pages.push(i);

      if (currentPage < totalPages - 3) pages.push("end-ellipsis");
      pages.push(totalPages - 1);
    }

    return pages;
  };

  const activeStyle = {
    color: "#fff",
    backgroundColor: "primary",
    borderColor: "#1c5a21",
  };

  const greenTextStyle = {
    color: "#1c5a21",
    fontWeight: 400,
  };

  const disabledTextStyle = {
    color: "#adb5bd",
  };

  return (
    <div className="d-flex justify-content-between align-items-center w-100 mt-3 flex-wrap gap-2">
      {showPageSizeDropdown && (
        <div className="d-flex align-items-center">
          <span className="me-2">Rows:</span>
          <ButtonGroup>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="button"
                className="btn btn-sm btn-primary"
                id="dropdownMenuButton"
                style={{ minWidth: "auto", width: "auto" }}
              >
                {pageSize} <i className="mdi mdi-chevron-down"></i>
              </DropdownToggle>
              <DropdownMenu style={{ minWidth: "auto", width: "auto" }}>
                {[5, 10, 20, 50].map((size) => (
                  <DropdownItem
                    key={size}
                    onClick={() => {
                      setPageSize?.(size);
                      setPageNo?.(0);
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    active={size === pageSize}
                  >
                    {size}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </UncontrolledDropdown>
          </ButtonGroup>
        </div>
      )}

      <Pagination className="mb-0 justify-content-center gap-1" size="sm">
        {/* Previous */}
        <PaginationItem disabled={currentPage === 0}>
          <PaginationLink
            onClick={(e) => {
              e.preventDefault();
              if (currentPage > 0) onPageChange(currentPage - 1);
              window.scrollTo({ top: 0, behavior: "smooth" });
              // scroll.scrollToTop({
              //   duration: 1200,
              //   smooth: "easeInOutCubic",
              // });
            }}
            style={currentPage === 0 ? disabledTextStyle : greenTextStyle}
          >
            Previous
          </PaginationLink>
        </PaginationItem>

        {/* Page Numbers */}
        {getPageNumbers().map((page, index) =>
          typeof page === "string" ? (
            <PaginationItem disabled key={`ellipsis-${index}`}>
              <PaginationLink
                onClick={(e) => e.preventDefault()}
                style={disabledTextStyle}
              >
                ...
              </PaginationLink>
            </PaginationItem>
          ) : (
            <PaginationItem key={page} active={page === currentPage}>
              <PaginationLink
                onClick={(e) => {
                  e.preventDefault();
                  onPageChange(page);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  // scroll.scrollToTop({
                  //   duration: 1200,
                  //   smooth: "easeInOutCubic",
                  // });
                }}
                style={page === currentPage ? activeStyle : greenTextStyle}
              >
                {page + 1}
              </PaginationLink>
            </PaginationItem>
          )
        )}

        {/* Next */}
        <PaginationItem disabled={currentPage === totalPages - 1}>
          <PaginationLink
            onClick={(e) => {
              e.preventDefault();
              if (currentPage < totalPages - 1) onPageChange(currentPage + 1);
              // scroll.scrollToTop({
              //   duration: 1200,
              //   smooth: "easeInOutCubic",
              // });
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            style={
              currentPage === totalPages - 1
                ? disabledTextStyle
                : greenTextStyle
            }
          >
            Next
          </PaginationLink>
        </PaginationItem>
      </Pagination>
    </div>
  );
};

export default CustomPagination;
